//------------------------------------------------------------------------------
// メニュー設定
//------------------------------------------------------------------------------
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import {
  MenuItem,
  MenuGroup,
  type MenuConfig,
} from '@/services/menu/menu-config';

//
// メニュー項目一覧
//
const root = new MenuGroup('menu');

// デモ共架
root.group('DEMO-1O', '共架物申請契約')
      .add('DEMO-1001', '申請状況一覧',     '/bfa10101g')
      .group('DEMO-11',  '共架物追加・撤去')
        .add('DEMO-1101', '通信線共架',   '/demo-1101')
        .add('DEMO-1102', '管路等使用',   '/demo-1102')
        .add('DEMO-1103', '機器共架',     '/demo-1103')
        .end()
      .group('DEMO-12',   '契約変更')
        .add('DEMO-1201', '請求先変更',   '/demo-1201')
        .add('DEMO-1202', '権利移転',     '/demo-1202')
        .add('DEMO-1203', '契約分割',     '/demo-1203')
        .add('DEMO-1204', '契約統合',     '/demo-1204')
        .end();

// デモ共用契約
root.group('DEMO-13',   '共用契約')
      .add('DEMO-1301', '申請状況一覧',   '/demo-1301')
      .add('DEMO-1302', '追加・撤去',     '/demo-1302')
      .end();

// デモ公共表示物契約
root.group('DEMO-14',   '公共表示物契約')
      .add('DEMO-1401', '申請状況一覧',          '/demo-1401')
      .add('DEMO-1402', '追加・撤去 通信線共架', '/demo-1402')
      .add('DEMO-1403', '追加・撤去 機器共架',   '/demo-1403')
      .end();

// デモ広告契約
root.group('DEMO-15',   '広告契約')
      .add('DEMO-1501', '申請状況一覧',  '/demo-1501')
      .add('DEMO-1502', '追加・撤去',    '/demo-1502')
      .end();

// デモ設備管理
root.group('DEMO-20',   '設備管理')
      .add('DEMO-2001', '移転依頼一覧',     '/demo-2001')
      .add('DEMO-2002', '改修依頼一覧',     '/demo-2002')
      .add('DEMO-2101', '電柱改番一覧',     '/demo-2101')
      .add('DEMO-2102', '地中設備改番一覧', '/demo-2101')
      .end();

// デモ照会
root.group('DEMO-70',   '照会')
      .add('DEMO-7001', '共架契約照会',   '/demo-7001')
      .add('DEMO-7011', '共用契約照会',   '/demo-7011')
      .add('DEMO-7012', '共用調書照会',   '/demo-7012')
      .add('DEMO-7021', '公共表示物照会', '/demo-7021')
      .add('DEMO-7031', '広告契約照会',   '/demo-7031')
      .end();

// デモその他
root.group('DEMO-90',   'その他')
      .add('DEMO-9001', '請求一覧',     '/demo-9001')
      .add('DEMO-9101', '契約設備一覧', '/demo-9101')
      .add('DEMO-9701', '事業者情報',   '/demo-9701')
      .add('DEMO-9702', 'ユーザー一覧', '/demo-9702')
      .add('DEMO-9703', 'ユーザー情報', '/demo-9703')
      .end();

//
// 以下、中部共架ベースの項目 - 権限マスタでメニュー非表示
//
// 共架申込
root.group('A00', '共架申込')
  .group('A00-01', '技術検討')
    .add('BFA10101G-XX', '技術検討申込',          '/bfa10101g')
    .add('BFA10408G',    '技術検討結果確認',      '/bfa10408g')
    .add('BFA10110G',    '受付審査',              '/bfa10110g')
    .add('BFA10118G-01', '担当割当(机上)',        '/bfa10118g/01')
    .add('BFA10403G',    '内容登録(机上)',        '/bfa10403g')
    .add('BFA10118G-02', '結果承認(机上)',        '/bfa10118g/02')
    .add('BFA10405G-01', '担当割当(現場)',        '/bfa10405g/01')
    .add('BFA10406G',    '内容登録(現場)',        '/bfa10406g')
    .add('BFA10405G-02', '結果承認(現場)',        '/bfa10405g/02')
    .end()
  .group('A00-05', '改修設計')
    .add('BFA10501G-01', '設計内容登録(配電)', '/bfa10501g/01')
    .add('BFA10501G-02', '設計内容登録(通信)', '/bfa10501g/02')
    .add('BFA10503G-01', '設計内容承認(配電)', '/bfa10503g/01')
    .add('BFA10503G-02', '設計内容承認(通信)', '/bfa10503g/02')
    .add('BFA10505G-01', '設計内容登録',       '/bfa10505g/01')
    .add('BFA10509G-01', '設計完了承認',       '/bfa10509g/01')
    .end()
  .group('A00-02', '共架本申込')
    .add('BFA10128G',    '申込登録',           '/bfa10128g')
    .add('BFA10527G-01', '改修工事日程確認',   '/bfa10527g/01')
    .add('BFA10130G',    '共架承認',           '/bfa10130g')
    .end()
  .group('A00-03', '共架工事')
    .add('BFA10527G-02', '共架承認/精算確認',  '/bfa10527g/02')
    .add('BFA10601G',    '共架しゅん工登録',   '/bfa10601g')
    .add('BFA10810G-01', '不適内容確認',       '/bfa10810g/01')
    .add('BFA10810G-02', '改修工事依頼申込',   '/bfa10810g/02')
    .end()
  .group('A00-06', '当社の改修工事')
    .add('BFA10515G-01', '工程情報登録(配電)', '/bfa10515g/01')
    .add('BFA10515G-02', '工程情報登録(通信)', '/bfa10515g/02')
    .add('BFA10525G-01', '改修工事費用精算',   '/bfa10525g/01')
    .end()
  .group('A00-07', '施設確認')
    .add('BFA10801G-01', '担当割当', '/bfa10801g/01')
    .add('BFA10804G-01', '内容登録', '/bfa10804g/01')
    .add('BFA10807G-01', '結果承認', '/bfa10807g/01')
    .end()
  .add('BFA10122G', '申込取消', '/bfa10122g');

// 所有権移転
root.add('BFD40101G', '所有権移転登録', '/bfd40101g');

// 改修通知
root.group('A01', '改修通知')
  .group('A01-01', '改修通知')
    .add('BFA10904G-01', '通知内容確認',     '/bfa10904g/01')
    .add('BFA10904G-02', '共架申込要否登録', '/bfa10904g/02')
    .add('BFA10904G-03', '改修工事依頼申込', '/bfa10904g/03')
    .end()
  .add('BFA10901G', '改修通知書登録', '/bfa10901g')
  .group('A01-02', '改修工事')
    .add('BFA10812G',    '可否判定担当割当',   '/bfa10812g')
    .add('BFA10814G',    '改修可否判定登録',   '/bfa10814g')
    .add('BFA10505G-02', '改修設計内容登録',   '/bfa10505g/02')
    .add('BFA10501G-01', '設計内容登録(配電)', '/bfa10501g/01')
    .add('BFA10501G-02', '設計内容登録(通信)', '/bfa10501g/02')
    .add('BFA10503G-01', '設計内容承認(配電)', '/bfa10503g/01')
    .add('BFA10503G-02', '設計内容承認(通信)', '/bfa10503g/02')
    .add('BFA10509G-02', '改修設計完了承認',   '/bfa10509g/02')
    .add('BFA10515G-01', '工程情報登録(配電)', '/bfa10515g/01')
    .add('BFA10515G-02', '工程情報登録(通信)', '/bfa10515g/02')
    .add('BFA10525G-01', '改修工事費用精算',   '/bfa10525g/01')
    .add('BFA10527G-03', '改修工事予定確認',   '/bfa10527g/03')
    .add('BFA10527G-04', '改修工事完了確認',   '/bfa10527g/04')
    .end()
  .add('BFA10904G-04', '改修完了報告', '/bfa10904g/04')
  .group('A01-05', '施設確認')
    .add('BFA10801G-01', '担当割当', '/bfa10801g/01')
    .add('BFA10804G-01', '内容登録', '/bfa10804g/01')
    .add('BFA10807G-01', '結果承認', '/bfa10807g/01')
    .end();

// 変更連絡
root.group('B00', '共架柱変更連絡')
  .group('B00-03', '事前連絡')
    .add('B10101G-01', '変更連絡票発行', '/bfb10101g/01')
    .add('B10101G-02', '変更連絡票編集', '/bfb10101g/01')
    .end()
  .add('B10101G-03', '本連絡', '/bfb10101g/03')
  .group('B00-01', '変更連絡票確認')
    .add('BFB10106G',    '変更連絡票確認', '/bfb10106g')
    .add('BFB10106G-01', '移設予定日登録', '/bfb10106g/01')
    .end()
  .group('B00-02', '移設登録')
    .add('BFB20101G-02', '移設結果登録',   '/bfb20101g/02')
    .add('BFB20101G-03', '本移設完了登録', '/bfb20101g/03')
    .add('BFB10106G-02', '移設結果登録',   '/bfb10106g/02')
    .add('BFB10106G-03', '本移設完了登録', '/bfb10106g/03')
    .end()
  .group('B1-06', '取消連絡')
    .add('BFB10101G-04', '変更連絡票取消', '/bfb10101g/04')
    .add('BFB10101G-05', '変更連絡票送付', '/bfb10101g/05')
    .end()
  .add('BFB20105G', '仮移設', '/bfb20105g')
  .end();

// 契約管理
root.group('U00', '契約/管理')
  .group('U00-01', '契約')
    .add('BFU10102G-01', '契約書確認', '/bfu10102g/01')
    .add('BFU70103G',    '約款確認',   '/bfu70103g')
    .end()
  .group('U00-02', '管理')
    .add('BFD10201G', '共架物件一覧',       '/bfd10201g')
    .add('BFD20201G', '共架柱登録確認',     '/bfd20201g')
    .add('BFU20105G', '共架者情報修正一覧', '/bfd20105g')
    .end();

// 契約/利用申込
root.group('U01', '契約/利用申込')
  .group('U01-01', '申込登録決済')
    .add('BFU10101G-01', '申込内容登録', '/bfu10101g/01')
    .add('BFU10101G-02', '契約決裁',     '/bfu10101g/02')
    .add('BFU10101G-03', '契約書送付',   '/bfu10101g/03')
    .add('BFU10101G-04', '契約書受領',   '/bfu10101g/04')
    .end()
  .add('BFU20104G', '編集申込一覧', '/bfu20104g')
  .add('BFU20201G', '契約解除',     '/bfu20201g')
  .end();

// 共架柱登録
root.add('BFD20101G', '共架柱登録', '/bfd20101g');

// 請求
root.group('E00', '請求')
  .add('BFE10101G-01', '請求一覧',         '/bfe10101g/01')
  .add('BFE10101G-02', '請求書再発行依頼', '/bfe10101g/02')
  .add('BFE30102G',    '修正申請一覧',     '/bfe30102g')
  .end();

// 検索
root.group('Z02', '検索')
  .add('BFU20101G', '共架事業者検索',   '/bfu20101g')
  .add('BFD10101G', '共架柱・物件検索', '/bfd10101g')
  .add('BFD10102G', '共架申込物件検索', '/bfd10102g')
  .end();

// 通知
root.group('I00', '通知')
  .add('BFI10101G', 'メッセージ一覧', '/bfi10101g')
  .add('BFI10201G', 'メッセージ一覧', '/bfi10201g')
  .add('BFI20101G', '重要事項登録',   '/bfi20101g')
  .add('BFI20201G', '重要事項通知',   '/bfi20201g')
  .end();

// 承認
root.group('Y00', '承認')
  .add('BFY20101G', '承認一覧', '/bfy20101g')
  .add('BFY20102G', '承認一覧', '/bfy10102g')
  .add('BFY20103G', '申請一覧', '/bfy20103g')
  .add('BFY20104G', '申請一覧', '/bfy20104g')
  .end();

// 支持物確認
root.add('BFD10301G', '支持物確認リスト', '/bfd10301g');

// 管理
root.group('Z99', '管理')
  .add('BFZ20101G', 'CSV一覧',    '/bfz20101g')
  .add('BFM10201G', '単価マスタ', '/bfm10201g')
  .add('DEMO1002',  '汎用マスタ', '/admin/mst-generic')
  .add('DEMO1001',  '操作履歴',   '/admin/ope-history')
  .add('DEMO1003',  'エラー履歴', '/admin/err-history')
  .end();

// ホームボタン
const home = new MenuItem(
    'home', 'home', 'ダッシュボードに戻る', '/',
    <HomeOutlinedIcon color="primary" />);

/**
 * メニュー設定
 */
export default {
  root,   // ルート項目
  home,   // ホーム項目
} satisfies MenuConfig;
